/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface APIKeyUpdateRequest {
  name?: string;
  disabled?: boolean;
}

export function APIKeyUpdateRequestFromJSON(json: any): APIKeyUpdateRequest {
  return APIKeyUpdateRequestFromJSONTyped(json);
}

export function APIKeyUpdateRequestFromJSONTyped(
  json: any,
): APIKeyUpdateRequest {
  if (json == null) {
    return json;
  }

  return {
    name: json["name"],
    disabled: json["disabled"],
  };
}

export function APIKeyUpdateRequestToJSON(
  value: APIKeyUpdateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value.name,
    disabled: value.disabled,
  };
}
